export default __webpack_public_path__ + "static/media/insta_bw.836971be.svg";